import { TTravelActivityTicketType } from "../TravelActivities"
import { ITransportService, INormalizedService } from "./store"

interface IServiceWrapper<T extends "transport" | "activity"> {
	type: T
	service: T extends "transport" ? ITransportService : TTravelActivityTicketType
}

export function normalizeService<T extends "transport" | "activity">(
	service: IServiceWrapper<T>["service"],
	type: IServiceWrapper<T>["type"]
): INormalizedService {
	if (type === "transport") {
		const transport = service as IServiceWrapper<"transport">["service"]
		return {
			id: transport.id,
			name:
				transport.service_wise_itineraries?.at(0)?.name ||
				transport.service_display_name,
			short_name: transport.service_short_name,
			distance: transport.distance ?? undefined,
			start_time_formatted: transport.start_time_formatted ?? undefined,
			duration_string: transport.duration_string ?? undefined,
			end_time_formatted: transport.end_time_formatted ?? undefined,
			closed_on_days_or_dates: transport.closed_on_days_or_dates ?? [],
			created_by: transport.created_by,
			created_at: transport.created_at,
			updated_by: transport.updated_by,
			updated_at: transport.updated_at,
			rate_uploaded_by: transport.rate_uploaded_by,
			rate_expiry_date: transport.rate_expiry_date ?? undefined,
			rate_expiry_date_local: transport.rate_expiry_date_local ?? undefined,
			deleted_at: transport.deleted_at ?? undefined,
			deleted_by: transport.deleted_by,
			latest_media: transport.latest_media,
			description: transport.service_wise_itineraries?.at(0)?.description,
		}
	} else {
		const ticket = service as IServiceWrapper<"activity">["service"]
		return {
			id: ticket.id,
			name: ticket.display_name || ticket.name,
			short_name: ticket.short_name,
			distance: undefined,
			start_time_formatted: undefined,
			duration_string:
				(ticket.durations || [])
					.map(
						({ name, slots }) =>
							`${name || ""}${slots?.length ? ` (${slots.join(", ")})` : ``}`
					)
					.join(" | ") ?? undefined,
			end_time_formatted: undefined,
			closed_on_days_or_dates: ticket.closed_on_days_or_dates ?? [],
			created_by: ticket.created_by,
			created_at: ticket.created_at,
			updated_by: ticket.updated_by,
			updated_at: ticket.updated_at,
			rate_uploaded_by: ticket.rate_uploaded_by,
			rate_expiry_date: ticket.rate_expiry_date,
			rate_expiry_date_local: ticket.rate_expiry_date_local ?? undefined,
			deleted_at: ticket.deleted_at ?? undefined,
			deleted_by: ticket.deleted_by,
			latest_media: ticket.latest_media,
			description: ticket.description || "Itinerary N/A",
		}
	}
}
